



import Vue from 'vue';
import Component from 'vue-class-component';
import {INITIAL_SESSION_TIMEOUT_SECOND, LIMITED_SESSION_TIMEOUT_SECOND} from '@/utils/Constants';
import ApiUtils from '@/utils/ApiUtils';
import {SessionTimerEventBus} from '@/store';

@Component({
    components: {}
})
export default class SessionTimer extends Vue {
    private sessionTime = INITIAL_SESSION_TIMEOUT_SECOND;
    private $tick: any;
    
    get timeRemaining() {
        const sessionTime = this.sessionTime;
        const minute = Math.floor(sessionTime / 60);
        const second = sessionTime - minute * 60;
        
        const formattedMinute = minute >= 10 ? minute : `0${minute}`;
        const formattedSecond = second >= 10 ? second : `0${second}`;
        return `${formattedMinute} : ${formattedSecond}`;
    }
    
    public created() {
        this.$tick = setInterval(() => {
            this.sessionTime--;
            if (this.isWarningDialogVisible()) {
                this.$modal.showSessionTimeoutWarningDialog();
            }

            if (this.sessionTime <= 0) {
                ApiUtils.logout(this.$route.params.sponsorKey,
                    'Logout - Session Expired', this.$store, this.$tick, this.$route);
            }
        }, 1000);
    }

    public onRefreshSessionTime() {
        this.sessionTime =  INITIAL_SESSION_TIMEOUT_SECOND;
    }

    public mounted() {
        SessionTimerEventBus.$on('extendSessionTime',
            () => this.onRefreshSessionTime());
    }

    private isWarningDialogVisible() {
        return this.sessionTime <= LIMITED_SESSION_TIMEOUT_SECOND
            && !this.$store.state.sessionExtendRejected;
    }

    public beforeDestroy() {
        clearInterval(this.$tick);
        SessionTimerEventBus.$off();
    }
}
